module.exports = __webpack_public_path__ + "img/pig-all.a49b5e14.webp";